//=============================================================================
// Global Breadcrumb component. 
//=============================================================================

/** Use as directive <breadcrumb>. Always add Home and current page.
 * For add custom breadcrumb betwen home and current use 'ng-model' and in
 * page controller items
 $scope.bpath = [{
 href: "/",
 title: "Title"
 }];
 ....
 <breadcrumb ng-model='bpath'></breadcrumb>
 */

(function() {
  'use strict';

  angular.module('app').directive('breadcrumb', Breadcrumb);

  // Directive
  Breadcrumb.$inject = ['$rootScope', '$location'];

  function Breadcrumb($rootScope, $location) {
    var innerController = function() {
      var ic = this;
      ic.thisPage = $rootScope.PAGE.title;
      ic.thisPageLink = '/' + $location.path().split('/')[1];
    };

    return {
      restrict: 'E',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/components/breadcrumb.html',
      controller: innerController,
      controllerAs: 'ic',
      bindToController: true
    };
  }
})();
